/**
 * DevExtreme (esm/__internal/ui/tabs/item.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../core/renderer";
import CollectionItem from "../../ui/collection/item";
export const TABS_ITEM_BADGE_CLASS = "dx-tabs-item-badge";
const BADGE_CLASS = "dx-badge";
class TabsItem extends CollectionItem {
  _renderWatchers() {
    super._renderWatchers();
    this._startWatcher("badge", this._renderBadge.bind(this));
  }
  _renderBadge(badge) {
    this._$element.children(".dx-badge").remove();
    if (!badge) {
      return;
    }
    const $badge = $("<div>").addClass("dx-tabs-item-badge").addClass("dx-badge").text(badge);
    this._$element.append($badge);
  }
}
export default TabsItem;